const login = {
    en: {
        loginDescription: "Wherever you are in the world, in whatever industry, you can rely on our international teams of experts to provide you with specialized business solutions to make your business faster, simpler and more efficient.",
        retrievePassword: "Recover Password",
        forgotMyPassword: "Forgot my password",
        enterYourUsername: "Enter your username:",
        textEmailSent: "A message has been sent to your email with instructions to reset your password.",
        inputNewPassword: "Enter the new password"
    },
    pt: {
        loginDescription: "Onde quer que esteja no mundo, seja qual for o seu setor de atuação, você pode confiar em nossas equipes internacionais de especialistas.",
        retrievePassword: "Recuperar senha",
        forgotMyPassword: "Esqueci minha senha",
        enterYourUsername: "Informe seu nome de usuário:",
        textEmailSent: "Foi enviado para o seu e-mail uma mensagem com instruções para redefinir a sua senha.",
        inputNewPassword: "Informe a nova senha"
    },
    es: {
        loginDescription: "En cualquier parte del mundo y en cualquier sector, puede confiar en nuestros equipos internacionales de expertos, que le ofrecerán soluciones comerciales especializadas para lograr una mayor rapidez, sencillez y eficacia en sus negocios.",
        retrievePassword: "Recuperar contraseña",
        forgotMyPassword: "Olvide mi contraseña",
        enterYourUsername: "Ingrese su nombre de usuario:",
        textEmailSent: "Se ha enviado un mensaje a su correo electrónico con instrucciones para restablecer su contraseña.",
        inputNewPassword: "Introduce la nueva contraseña"
    }
};

export default {
    ...login
}



// WEBPACK FOOTER //
// ./src/app/auth/i18nLogin.js